import * as XLSX from "xlsx";
import { strFromU8, strToU8, unzipSync, zipSync } from "fflate";
import { evBrand, getEvLogoBytes } from "./evBranding.js";

const drawing = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<xdr:wsDr xmlns:xdr="http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing"
 xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main"
 xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">
 <xdr:oneCellAnchor><xdr:from><xdr:col>0</xdr:col><xdr:colOff>0</xdr:colOff><xdr:row>0</xdr:row><xdr:rowOff>0</xdr:rowOff></xdr:from>
 <xdr:ext cx="620000" cy="620000"/><xdr:pic><xdr:nvPicPr><xdr:cNvPr id="1" name="Company logo"/><xdr:cNvPicPr/></xdr:nvPicPr>
 <xdr:blipFill><a:blip r:embed="rId1"/><a:stretch><a:fillRect/></a:stretch></xdr:blipFill>
 <xdr:spPr><a:xfrm><a:off x="0" y="0"/><a:ext cx="620000" cy="620000"/></a:xfrm>
 <a:prstGeom prst="rect"><a:avLst/></a:prstGeom></xdr:spPr></xdr:pic><xdr:clientData/></xdr:oneCellAnchor>
</xdr:wsDr>`;

export function brandedSheet(title, rows, details) {
  const brand = evBrand(details);
  const sheet = XLSX.utils.aoa_to_sheet([["", brand.name], ["", brand.address], ["", title], [], ...rows]);
  sheet["!rows"] = [{ hpx: 72 }, { hpx: 28 }, { hpx: 24 }];
  sheet["!cols"] = [{ wpx: 118 }, { wpx: 180 }];
  return sheet;
}

export async function saveBrandedWorkbook(workbook, filename) {
  const original = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const files = unzipSync(new Uint8Array(original));
  const sheetPath = "xl/worksheets/sheet1.xml";
  let sheet = strFromU8(files[sheetPath]);
  if (!sheet.includes("xmlns:r=")) sheet = sheet.replace("<worksheet ",
    '<worksheet xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" ');
  sheet = sheet.replace("</worksheet>", '<drawing r:id="rId1"/></worksheet>');
  files[sheetPath] = strToU8(sheet);
  files["xl/worksheets/_rels/sheet1.xml.rels"] = strToU8(`<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
    <Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
    <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing" Target="../drawings/drawing1.xml"/>
    </Relationships>`);
  files["xl/drawings/drawing1.xml"] = strToU8(drawing);
  files["xl/drawings/_rels/drawing1.xml.rels"] = strToU8(`<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
    <Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
    <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image" Target="../media/ev-company-logo.png"/>
    </Relationships>`);
  files["xl/media/ev-company-logo.png"] = await getEvLogoBytes();
  let contentTypes = strFromU8(files["[Content_Types].xml"]);
  if (!contentTypes.includes('Extension="png"')) contentTypes = contentTypes.replace("</Types>",
    '<Default Extension="png" ContentType="image/png"/></Types>');
  contentTypes = contentTypes.replace("</Types>",
    '<Override PartName="/xl/drawings/drawing1.xml" ContentType="application/vnd.openxmlformats-officedocument.drawing+xml"/></Types>');
  files["[Content_Types].xml"] = strToU8(contentTypes);
  const blob = new Blob([zipSync(files, { level: 6 })], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url; link.download = `${filename}.xlsx`; document.body.append(link); link.click(); link.remove();
  const timeout = setTimeout(() => URL.revokeObjectURL(url), 30000);
  timeout.unref?.();
}
